import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL, ENDPOINTS, getData } from '../../constants/api';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import { useParams } from 'react-router-dom';
import BackButton from '../../components/BackButton';

export default function DoctorPortal() {
  const [tests, setTests] = useState([]);
  const [selectedTests, setSelectedTests] = useState([]);
  const { route, appointment_id } = useParams();
  const [searchTerm, setSearchTerm] = useState('');

  // Example variables (replace with your actual logic)
  const token = getToken();
  const user_id = decodeToken(token, 'id');
  const date = new Date().toISOString().split('T')[0]; // e.g. '2025-07-03'
  const SUBMIT_URL = `${API_URL}/${ENDPOINTS.SYS}/create/register-caafi_lab_request`;
  const generateRefNo = () => {
    return Math.floor(100000 + Math.random() * 900000); // 6-digit int
  };
  const ref_no = generateRefNo();
  useEffect(() => {
    // Fetch the data from your API
    const url = `${API_URL}/${ENDPOINTS.SYS}/getlink/${route}`;
    const fetchData = async () => {
      const response = await getData(url);
      setTests(response.report);
    };
    fetchData();
  }, []);

  const handleCheckboxChange = (testName) => {
    setSelectedTests((prev) =>
      prev.includes(testName)
        ? prev.filter((name) => name !== testName)
        : [...prev, testName]
    );
  };
  const handleGroupCheckboxChange = (groupName) => {
    const groupItems = groupedTests[groupName].tests.map(
      (item) => item.TestName
    ); // ✅ FIXED
    const allSelected = groupItems.every((name) =>
      selectedTests.includes(name)
    );

    if (allSelected) {
      // Uncheck all in this group
      setSelectedTests((prev) =>
        prev.filter((name) => !groupItems.includes(name))
      );
    } else {
      // Add missing ones
      setSelectedTests((prev) => [
        ...prev,
        ...groupItems.filter((name) => !prev.includes(name)),
      ]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const selectedLabItems = tests.filter((test) =>
      selectedTests.includes(test.TestName)
    );

    const requests = selectedLabItems.map((item) => {
      const body = {
        user_id,

        appointment_id,
        lab_item_id: item.labItemId, // assumes your test object has labItemId field
        status: 'scheduled',
        ref_no: ref_no,
      };

      return axios
        .post(SUBMIT_URL, body, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        })
        .then((response) => {
          console.log(`Submitted:`, body, 'Response:', response.data);
          return response.data;
        })
        .catch((error) => {
          console.error(`Error submitting:`, body, error);
          throw error;
        });
    });

    try {
      const results = await Promise.all(requests);
      console.log('All submitted:', results);
      // Count success and failed
      let successCount = 0;
      let failedCount = 0;

      results.forEach((result) => {
        if (result.status === false) {
          failedCount++;
        } else {
          successCount++;
        }
      });

      alert(
        `Tests submitted.\nSuccess: ${successCount}\nFailed: ${failedCount}`
      );
    } catch (error) {
      alert('Some requests failed — check console for details.');
    }
  };

  const filteredItems = tests.filter((item) => {
    const search = searchTerm.toLowerCase();
    return (
      item.TestName.toLowerCase().includes(search) ||
      item.Group.toLowerCase().includes(search)
    );
  });

  // Group tests by `Group`
  const groupedTests = filteredItems.reduce((acc, test) => {
    if (!acc[test.Group]) {
      acc[test.Group] = { category: test.Category, tests: [] };
    }
    acc[test.Group].tests.push(test);
    return acc;
  }, {});

  return (
    <div style={{ padding: '2rem' }}>
      <div className="text-end mb-3">
        <BackButton />
      </div>
      <div className="row">
        <div className="col-3">
          {' '}
          <h1>Lab Tests Request</h1>
        </div>
        <div className="col-9">
          {' '}
          <input
            type="text"
            placeholder="Search..."
            className="form-control mb-3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '1rem',
          }}
        >
          {Object.entries(groupedTests).map(([groupName, groupData]) => {
            const groupItems = groupData.tests.map((test) => test.TestName);
            const allSelected = groupItems.every((name) =>
              selectedTests.includes(name)
            );

            return (
              <div
                key={groupName}
                style={{
                  border: '1px solid #ddd',
                  borderRadius: '6px',
                  padding: '1rem',
                  background: '#fafafa',
                }}
              >
                <h6>
                  <label>
                    <input
                      type="checkbox"
                      checked={allSelected}
                      onChange={() => handleGroupCheckboxChange(groupName)}
                      style={{ marginRight: '0.5rem' }}
                    />
                    {groupName}{' '}
                    {/* <span style={{ fontSize: '0.85rem', color: '#555' }}>
                      ({category})
                    </span> */}
                  </label>
                </h6>
                <ul
                  style={{
                    listStyle: 'none',
                    padding: 0,
                    margin: 0,
                    marginLeft: 20,
                  }}
                >
                  {groupData.tests.map((test) => (
                    <li key={test.TestName} style={{ marginBottom: '0.5rem' }}>
                      <label>
                        <input
                          type="checkbox"
                          checked={selectedTests.includes(test.TestName)}
                          onChange={() => handleCheckboxChange(test.TestName)}
                          style={{ marginRight: '0.5rem' }}
                        />
                        {test.TestName}
                      </label>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
        <button
          type="submit"
          style={{
            marginTop: '2rem',
            padding: '0.75rem 1.5rem',
            fontSize: '1rem',
          }}
        >
          Submit Selected Tests
        </button>
      </form>
    </div>
  );
}
